import { useMutation, UseMutationResult } from 'react-query'
import postGiftRedeemPlasticVisa, {
    TGiftRedemptionPlasticQueryResult,
} from '@/src/common/queries/PostGiftRedeemPlasticVisa'

const useFetchGiftRedeemPlastic =
    (): UseMutationResult<TGiftRedemptionPlasticQueryResult> => {
        return useMutation(
            'postGiftRedeemPlasticVisa',
            postGiftRedeemPlasticVisa
        )
    }

export default useFetchGiftRedeemPlastic
